import styled from "styled-components";

const Container = styled.section`
    display: none;
   .wrapper {
        // the wrapper acts as the submenus' positioned parent
        position: relative;
    }

    ul {
        width: 200px;
        max-height: 250px;
        
        // use scrolling if necessary, but don't show a horizontal scrollbar
        overflow-x: hidden;
        overflow-y: auto;
    }

    li {
        // the submenus cannot have a positioned parent inside the scrollable list
        /* position: static; */
        
        // submenu
        .wrapper {
            // position on top of the menu item
            position: absolute;
            
            // these are not useful because our positioned parent is not the menu item
            /* top: 0;
            left: 75%; */
            
            // show on top of the menu item
            z-index: 10;
            
            // do not show the submenu by default
            display: none;
        }
        
        // display the submenu when we hover on the menu item
        &:hover > .wrapper {
            display: block;
        }
    }

    // for decoration purposes
    --c1: #0E8CE0;
    --c2: #0064B3;
    --c3: #00B99B;
    ul {
        margin: 1em;
        color: white;
        font-family: sans-serif;
        font-size: 16px;
    }

    li {
        padding: 1em;
        ul {
            margin: 0;
        }
        .wrapper {
            cursor: auto;
            li {
                padding: 0.5em;
            }
        }
        &:nth-child(2n) {
            background: var(--c1);
        }
        &:nth-child(2n+1) {
            background: var(--c2);
        }
        &.parent {
            background: var(--c3);
            cursor: pointer;
        }
    }
`;
const ContainerTwo = styled.section`
    position: absolute;
    top: 30%;
    left: 30%;
    width: 400px;
    height: 400px;
    background-color: #ff3344;
    padding: 10px;
    & * {
        margin: 0;
    }
    & div {
        /* position: relative; */
        background-color: #33ff44;
        padding: 30px 10px;
        overflow: scroll;
        height: 70%;
    }
    & h2 {
        background-color: #3344ff;
        position: absolute;
        padding: 20px 500px;
    }
`;

const Test = () => {
    return (
        <>
        <Container>
            <div className="wrapper">
                <ul>
                    <li>Abc</li>
                    <li>Def</li>
                    <li>Ghi</li>
                    <li>Jkl</li>
                    <li className="parent">Mno
                        <div className="wrapper">
                            <ul>
                                <li>Abc</li>
                                <li>Def</li>
                                <li>Ghi</li>
                                <li>Jkl</li>
                                <li className="parent">Mno 
                                    <div className="wrapper">
                                        <ul>
                                            <li>Abc</li>
                                            <li>Def</li>
                                            <li>Ghi</li>
                                            <li>Jkl</li>
                                            <li>Mno</li>
                                            <li>Pqr</li>
                                            <li>Stu</li>
                                            <li>Vw</li>
                                            <li>Xyz</li>
                                        </ul>
                                    </div>
                                </li>
                                <li>Pqr</li>
                                <li>Stu</li>
                                <li>Vw</li>
                                <li>Xyz</li>
                            </ul>
                        </div>
                    </li>
                    <li>Pqr</li>
                    <li>Stu</li>
                    <li>Vw</li>
                    <li>Xyz</li>
                    <li className="parent">Abc
                        <div className="wrapper">
                            <ul>
                                <li>Abc</li>
                                <li>Def</li>
                                <li>Ghi</li>
                                <li>Jkl</li>
                                <li>Mno</li>
                                <li>Pqr</li>
                                <li>Stu</li>
                                <li>Vw</li>
                                <li>Xyz</li>
                            </ul>
                        </div>
                    </li>
                    <li>Def</li>
                    <li>Ghi</li>
                    <li>Jkl</li>
                    <li>Mno</li>
                    <li>Pqr</li>
                    <li>Stu</li>
                    <li>Vw</li>
                    <li>Xyz</li>
                </ul>
            </div>
        </Container>
        <ContainerTwo>
            <div>
                <section>
                    <section>
                        <section>
                        <h2>Ga 2</h2>
                        </section>
                    </section>
                </section>
               {Array(15).fill().map(() => <h3>Ga 2</h3>)}
            </div>
        </ContainerTwo>
        </>
    );
}

export default Test;